<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col lg="4">
        <v-dialog v-model="show">
          <v-card>
            <v-toolbar
              :color="getImportanceColor(reminderItem.importance)"
              dark
            >
              <v-toolbar-title v-html="reminderItem.name" />
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="reminderItem.name"
                    label="Наименование уведомления"
                  />
                </v-col>
              </v-row>
              <!--              <v-row>-->
              <!--                <v-col>-->
              <!--                  <v-select-->
              <!--                    v-model="reminderItem.event"-->
              <!--                    :items="reminderEvent"-->
              <!--                    label="Выбор события"-->
              <!--                  />-->
              <!--                </v-col>-->
              <!--              </v-row>-->
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="reminderItem.content"
                    label="Текст уведомления"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    v-model="reminderItem.importance"
                    :items="reminderImportance"
                    label="Важность"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    readonly
                    :value="chosenUsers.map(chosenUser => `${chosenUser.text} `)"
                    label="Кому"
                  >
                    <template
                      v-slot:append-outer
                    >
                      <v-menu
                        offset-y
                        style="top: -12px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            @click="onOpenDialog"
                            v-on="on"
                          >
                            mdi-account-search-outline
                          </v-icon>
                        </template>
                      </v-menu>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <!--              <v-row>-->
              <!--                <v-col>-->
              <!--                  <v-select-->
              <!--                    v-model="reminderItem.receiver"-->
              <!--                    :items="users"-->
              <!--                    label="Кому"-->
              <!--                    multiple-->
              <!--                  >-->
              <!--                    <template v-slot:prepend-item>-->
              <!--                      <v-data-table />-->
              <!--                    </template>-->
              <!--                  </v-select>-->
              <!--                </v-col>-->
              <!--              </v-row>-->
              <!--              <v-row>-->
              <!--                <v-col cols="1">-->
              <!--                  <span>Дата начала</span>-->
              <!--                </v-col>-->
              <!--                <v-col cols="3">-->
              <!--                  <v-menu-->
              <!--                    v-model="dateMenuFrom"-->
              <!--                    :close-on-content-click="false"-->
              <!--                    :nudge-right="40"-->
              <!--                    min-width="auto"-->
              <!--                    offset-y-->
              <!--                    transition="scale-transition"-->
              <!--                  >-->
              <!--                    <template v-slot:activator="{ on, attrs }">-->
              <!--                      <v-text-field-->
              <!--                        :value="formattedDate(dateFrom)"-->
              <!--                        prepend-icon="mdi-calendar"-->
              <!--                        clearable-->
              <!--                        readonly-->
              <!--                        v-bind="attrs"-->
              <!--                        @input="onInputDate"-->
              <!--                        v-on="on"-->
              <!--                        @click:clear="onClearDateFrom()"-->
              <!--                      />-->
              <!--                    </template>-->
              <!--                    <v-date-picker-->
              <!--                      v-model="dateFrom"-->
              <!--                      first-day-of-week="1"-->
              <!--                      locale="ru-RU"-->
              <!--                      @input="onInputDate"-->
              <!--                    />-->
              <!--                  </v-menu>-->
              <!--                </v-col>-->
              <!--                <v-col cols="2">-->
              <!--                  <v-menu-->
              <!--                    ref="menu"-->
              <!--                    v-model="timeMenuFrom"-->
              <!--                    :close-on-content-click="false"-->
              <!--                    :nudge-right="40"-->

              <!--                    min-width="auto"-->
              <!--                    offset-y-->
              <!--                    transition="scale-transition"-->
              <!--                  >-->
              <!--                    <template v-slot:activator="{ on, attrs }">-->
              <!--                      <v-text-field-->
              <!--                        v-model="timeFrom"-->
              <!--                        prepend-icon="mdi-clock-time-four-outline"-->
              <!--                        clearable-->
              <!--                        readonly-->
              <!--                        v-bind="attrs"-->
              <!--                        @input="onInputTime"-->
              <!--                        v-on="on"-->
              <!--                        @click:clear="onClearTimeFrom()"-->
              <!--                      />-->
              <!--                    </template>-->
              <!--                    <v-time-picker-->
              <!--                      v-if="timeMenuFrom"-->
              <!--                      v-model="timeFrom"-->
              <!--                      format="24hr"-->
              <!--                      @input="onInputTime"-->
              <!--                      @click:minute="$refs.menu.save(timeFrom)"-->
              <!--                    />-->
              <!--                  </v-menu>-->
              <!--                </v-col>-->
              <!--                <v-col cols="1">-->
              <!--                  <span>Дата конца</span>-->
              <!--                </v-col>-->
              <!--                <v-col cols="2">-->
              <!--                  <v-menu-->
              <!--                    v-model="dateMenuTo"-->
              <!--                    :close-on-content-click="false"-->
              <!--                    :nudge-right="40"-->
              <!--                    min-width="auto"-->
              <!--                    offset-y-->
              <!--                    transition="scale-transition"-->
              <!--                  >-->
              <!--                    <template v-slot:activator="{ on, attrs }">-->
              <!--                      <v-text-field-->
              <!--                        :value="formattedDate(dateTo)"-->
              <!--                        prepend-icon="mdi-calendar"-->
              <!--                        clearable-->
              <!--                        readonly-->
              <!--                        v-bind="attrs"-->
              <!--                        @input="onInputDate"-->
              <!--                        v-on="on"-->
              <!--                        @click:clear="onClearDateTo()"-->
              <!--                      />-->
              <!--                    </template>-->
              <!--                    <v-date-picker-->
              <!--                      v-model="dateTo"-->
              <!--                      first-day-of-week="1"-->
              <!--                      locale="ru-RU"-->
              <!--                      @input="onInputDate"-->
              <!--                    />-->
              <!--                  </v-menu>-->
              <!--                </v-col>-->
              <!--                <v-col cols="2">-->
              <!--                  <v-menu-->
              <!--                    ref="menu2"-->
              <!--                    v-model="timeMenuTo"-->
              <!--                    :close-on-content-click="false"-->
              <!--                    :nudge-right="40"-->

              <!--                    min-width="auto"-->
              <!--                    offset-y-->
              <!--                    transition="scale-transition"-->
              <!--                  >-->
              <!--                    <template v-slot:activator="{ on, attrs }">-->
              <!--                      <v-text-field-->
              <!--                        v-model="timeTo"-->
              <!--                        prepend-icon="mdi-clock-time-four-outline"-->
              <!--                        clearable-->
              <!--                        readonly-->
              <!--                        v-bind="attrs"-->
              <!--                        @input="onInputTime"-->
              <!--                        v-on="on"-->
              <!--                        @click:clear="onClearTimeFrom()"-->
              <!--                      />-->
              <!--                    </template>-->
              <!--                    <v-time-picker-->
              <!--                      v-if="timeMenuTo"-->
              <!--                      v-model="timeTo"-->
              <!--                      format="24hr"-->
              <!--                      @input="onInputTime"-->
              <!--                      @click:minute="$refs.menu2.save(timeTo)"-->
              <!--                    />-->
              <!--                  </v-menu>-->
              <!--                </v-col>-->
              <!--              </v-row>-->
            </v-card-text>
            <v-card-actions class="d-flex justify-sm-space-around justify-center flex-wrap">
              <v-btn @click="onCancel">
                Отмена
              </v-btn>
              <!-- that below button is  only for creating notification -->
              <v-btn
                v-if="!reminderItem.id"
                color="primary"
                @click="onSave"
              >
                Сохранить
              </v-btn>
              <v-btn
                v-if="$store.state.access[36][3] || ($store.state.access[36][4] && isNotificationOwner())"
                color="error"
                @click="onDelete"
              >
                Удалить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <item-list
          :multiple="true"
          :dialog-visible="chooseUserDialogVisible"
          :headers="usersChooseHeaders"
          :item-list="users"
          item-key="value"
          title="Выберите пользователя"
          @close="chooseUserDialogVisible = false"
          @getItem="onSetUser"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
    getImportanceColor,
    ReminderEvent,
    ReminderImportance,
    ReminderModel
} from "@/views/reminder/models/reminder.model"
import { ReminderService } from "@/views/reminder/shared/services/reminder-service"
import { ReminderDateTimeService } from "@/views/reminder/shared/services/reminder-datetime-service"
import ItemList from "@/views/loyalty/shared/components/item-list/ItemList.vue"

export default {
    name: "ReminderEdit",
    components: { ItemList },
    // model: {
    //     props: 'reminderItem',
    //     event: 'reminderSaved'
    // },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        reminderItem: {
            type: Object,
            default: () => (new ReminderModel())
        },
        users: {
            default: []
        }
    },
    data: () => ({
        chooseUserDialogVisible: false,
        chosenUsers: [],
        clientId: null,
        dateFrom: null,
        dateTo: null,
        dateMenuFrom: false,
        dateMenuTo: false,
        reminderEvent: [],
        reminderImportance: [],
        // reminderItem: new ReminderModel(),
        reminderService: null,
        timeFrom: null,
        timeTo: null,
        timeMenuFrom: false,
        timeMenuTo: false,
        userId: null,
        usersChooseHeaders: [
            {
                text: "Наименование",
                value: "text"
            },
            // {
            //     text: "Выбрать",
            //     value: "actions",
            //     sortable: false
            // }
        ],
        userChooseList: [],
    }),
    computed: {
        show: {
            get: function () {
                return this.dialogVisible
            },
            set: function () {
                this.$emit("close")
            }
        }
    },
    watch: {
        reminderItem () {
            this.dateFrom = ReminderDateTimeService.getDate(this.reminderItem.dateFrom)
            this.dateTo = ReminderDateTimeService.getDate(this.reminderItem.dateTo)
            this.timeFrom = ReminderDateTimeService.getTime(this.reminderItem.dateFrom)
            this.timeTo = ReminderDateTimeService.getTime(this.reminderItem.dateTo)
        },
    },
    beforeMount () {
        this.reminderService = new ReminderService()
        // this.timeFrom = ReminderDateTimeService.getTime(this.reminderItem.dateFrom)
        // console.log('timeFrom:', this.timeFrom)
    },
    mounted () {
        // this.reminderImportance = Object.assign({}, ReminderImportance)
        console.log('this.$store.state.client', this.$store.state.client)
        this.clientId = this.$store.state.client ? this.$store.state.client.id : "0"
        console.log('this.$store.state.user.id', this.$store.state.user.id)
        this.userId = this.$store.state.user.id
        this.reminderImportance = ReminderImportance.map(itemImportance => {
            Reflect.deleteProperty(Object.assign({}, itemImportance), 'color')
            return itemImportance
        })
        console.log('this.reminderImportance', this.reminderImportance)
        // eslint-disable-next-line no-undef
        this.reminderEvent = ReminderEvent
        console.log('ReminderEdit reminderItem:', this.reminderItem)
        console.log('reminderEdit users', this.users)
        // console.log('value id users', this.users.map(user => user.id))
        // this.userChooseList = this.users
    },

    methods: {
        getImportanceColor,
        formattedDate: function (date) {
            // console.log('formattedDate this.filterStuff', this.filterStuff)
            let formattedDate = ""
            const options = {
                weekday: "short",
                year: "numeric",
                month: "2-digit",
                day: "numeric"
            }
            if (date) {
                formattedDate = new Date(date).toLocaleDateString('ru-RU', options)
            }
            return formattedDate
        },
        formattedTime: function (time) {
        },
        isNotificationOwner () {
            return this.userId === this.reminderItem.initiator
        },
        onCancel () {
            this.$emit("close")
        },
        onClearDateFrom () {
            // delete this.filterStuff[index].fieldDate.from
            // if (!('to' in this.filterStuff[index].fieldDate)) {
            //     this.filterStuff[index].fieldTitle = ''
            // }
        },
        onClearDateTo () {
            // delete this.filterStuff[index].fieldDate.to
            // if (!('from' in this.filterStuff[index].fieldDate)) {
            //     this.filterStuff[index].fieldTitle = ''
            // }
        },
        onClearTimeFrom () {
        },
        onDelete () {
            this.$emit('delete', this.reminderItem)
        },
        onInputDate (newDate) {
            console.log('newDate', newDate)
            this.dateMenuFrom = false
            this.dateMenuTo = false
        },
        onInputTime (newDate) {
        },
        onOpenDialog () {
            this.chooseUserDialogVisible = true
        },
        onSave () {
            console.log('setDatetime:', ReminderDateTimeService.setDatetime(this.dateFrom, this.timeFrom))
            this.reminderItem.sender = this.clientId
            this.reminderItem.initiator = this.userId
            this.reminderItem.dateFrom = ReminderDateTimeService.setDatetime(this.dateFrom, this.timeFrom)
            this.reminderItem.dateTo = ReminderDateTimeService.setDatetime(this.dateTo, this.timeTo)
            this.reminderItem.receiver = this.chosenUsers.map(chosenUser => chosenUser.value)
            this.$emit("save", this.reminderItem)
        },
        onSetUser (chosenUsers) {
            console.log('onSetUser item', chosenUsers)
            this.chosenUsers = chosenUsers
        }
    }
}
</script>

<style scoped>

</style>
